import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { PerfilFrmComponent } from '../perfil-frm/perfil-frm.component';

@Component({
  selector: 'app-perfil-edicao',
  templateUrl: './perfil-edicao.component.html',
  styleUrls: ['./perfil-edicao.component.css'],
})
export class PerfilEdicaoComponent implements OnInit {
  @ViewChild(PerfilFrmComponent, { static: true })
  frm!: PerfilFrmComponent;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      if (params['id']) {
        this.frm.iniciarAlteracaoPorId(+params['id']);
      } else {
        this.frm.iniciarInsercao();
      }
    });
  }
}
